import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useEffect, useState } from 'react';

/**
 * Hook to get the app version across all platforms (iOS, Android, Web)
 *
 * - On native platforms (iOS/Android): Uses Capacitor App.getInfo() to get version from build settings
 * - On web platform: Uses version injected from package.json via Vite config
 *
 * @returns {string} The app version (e.g., "2.1.1")
 */
export const useAppVersion = (): string => {
  const [version, setVersion] = useState<string>('');

  useEffect(() => {
    const fetchAppVersion = async () => {
      if (Capacitor.isNativePlatform()) {
        // Native platforms (iOS/Android) - get from build settings
        try {
          const info = await App.getInfo();
          setVersion(info.version);
        } catch (error) {
          console.error('Error fetching app info:', error);
          setVersion('Unknown');
        }
      } else {
        // Web platform - use version injected by Vite from package.json
        const webVersion = import.meta.env.VITE_APP_VERSION;
        setVersion(webVersion || 'Unknown');
      }
    };

    fetchAppVersion();
  }, []);

  return version;
};
